import {Injectable} from '@angular/core';
import {WarehouseService} from './warehouse.service';
import {HttpService} from '../core/services/http.service';
import {HttpServiceBase, Page, PageRequest} from '../core/services/HttpServiceBase';
import {CardConditionService} from './card-condition.service';
import {isNullOrUndefined} from 'util';
import {LanguageService} from './language.service';
import * as Rx from 'rxjs/Rx';
import {Stock, StockFilter, StockInventoryProduct} from '../core/entities/entities';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class StockInventoryService extends HttpServiceBase<StockInventoryProduct> {
  getUrl(): string {
    return 'stockInventoryProduct';
  }

  protected init(): void {
  }

  public fromJson(json): StockInventoryProduct {
    const me = this;
    const item: StockInventoryProduct = Object.assign(this.getCleanInstance(), json);

    if(item && !isNullOrUndefined(item.stockInventoryDefinition) ){

      if(!isNullOrUndefined(item.stockInventoryDefinition.language)){
        item.stockInventoryDefinition.language = this.languageService.fromJson(json.stockInventoryDefinition.language );
      }
      if(!isNullOrUndefined(item.stockInventoryDefinition.minCondition)){
        item.stockInventoryDefinition.minCondition = this.cardCondService.fromJson(json.stockInventoryDefinition.minCondition );
      }
      if(!isNullOrUndefined(item.stockInventoryDefinition.maxCondition)){
        item.stockInventoryDefinition.maxCondition = this.cardCondService.fromJson(json.stockInventoryDefinition.maxCondition );
      }


    }
    return item;
  }

  getCleanInstance(): StockInventoryProduct {
    return new StockInventoryProduct();
  }


  search(filters: {}, page?: PageRequest): Observable<Page<StockInventoryProduct>> {

    const me = this;
    let url = me._url;

    if (filters) {
      filters = Object.keys(filters)
        .filter(k => !isNullOrUndefined(filters[k]) && 'null' != filters[k] && 'undefined' != filters[k])
        .reduce((previousValue, k) => {
          previousValue[k] = filters[k];
          return previousValue;
        }, {});
    }

    return Rx.Observable.create((observer: any) => {
      me.loadPage(filters, page, me._url).subscribe(ret => observer.next(ret));

    });
  }


  constructor(protected http: HttpService,private cardCondService: CardConditionService, private languageService: LanguageService) {
    super(http);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/stock-inventory.service.ts